import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const ShieldIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg viewBox="0 0 101 101" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1760_592)">
        <path
          d="M50.5 0L48.1012 1.13625L3.91375 19.695L0 21.3363V25.25C0 46.2075 8.45875 64.64 18.5588 78.1488C23.6088 84.84 29.0375 90.395 34.34 94.3087C39.6425 98.2225 44.8187 101 50.5 101C56.3075 101 61.3575 98.2225 66.66 94.3087C71.9625 90.395 77.3913 84.84 82.4413 78.1488C92.5413 64.64 101 46.2075 101 25.25V21.3363L97.0863 19.695L52.8988 1.13625L50.5 0ZM50.5 13.7613V88.375C49.995 88.375 46.3337 87.4912 42.1675 84.4613C38.0012 81.4313 33.2038 76.5075 28.785 70.7C19.8185 58.6416 14.4756 44.2769 13.3825 29.29L50.5 13.8875V13.7613Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1760_592">
          <rect width="101" height="101" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </StyledSvgIcon>
);
export default ShieldIcon;

ShieldIcon.propTypes = customIconsPropTypes;
